<template>
  <div ref="projectTableWrapper" class="project-table-wrapper">
    <el-table
      ref="table"
      :data="projects"
      :height="tableHeight"
      class="col-1"
      border
      size="mini"
      tooltip-effect="dark"
      highlight-current-row
      v-tablescroll="loadMore"
    >
      <el-table-column type="index" align="center" width="45" />
      <el-table-column prop="编号" label="项目编号" show-overflow-tooltip min-width="100" />
      <el-table-column label="操作" align="center" width="45">
        <template slot-scope="scope">
          <a :id="`h${scope.row._id}`" class="popper-btn" @click="showDropdown(scope.row, `h${scope.row._id}`)">
            <i class="el-icon-setting" />
          </a>
        </template>
      </el-table-column>
      <el-table-column prop="files" label="附件" align="center" width="45">
        <template slot-scope="scope">
          <a :id="`f${scope.row._id}`" class="pointer popper-btn" @click="showFiles(scope.row, `f${scope.row._id}`)">
            {{ (scope.row.files && scope.row.files.length) || 0 }}
          </a>
        </template>
      </el-table-column>
      <el-table-column label="项目名称" sortable="custom" show-overflow-tooltip min-width="160">
        <template slot-scope="scope">
          <a
            :href="`#/project20/${scope.row.pid || scope.row._id}`"
            target="_blank"
            >{{ scope.row['项目名称'] || '--' }}</a
          >
          <el-tag v-if="scope.row['独家']" class="cell-multi-item" size="mini">独家</el-tag>
          <el-tag v-if="showAdvanced(scope.row)" class="cell-multi-item" size="mini">高端</el-tag>
          <el-tag v-if="scope.row['保密']" class="cell-multi-item" size="mini">保密</el-tag>
          <el-tag v-if="scope.row['新增']" class="cell-multi-item" size="mini">新增</el-tag>
          <el-tag v-if="scope.row['替代']" class="cell-multi-item" size="mini">替代</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="客户公司" sortable="custom" min-width="100" show-overflow-tooltip>
        <template slot-scope="scope">
          <a class="pointer col-0" @click="onClickName('公司', scope.row['客户公司'])">
            {{ scope.row['客户公司'] || '--' }}
          </a>
        </template>
      </el-table-column>
      <el-table-column sortable="custom" prop="部门" label="部门" min-width="120" />
      <el-table-column prop="职能模块" sortable="custom" label="职能模块" min-width="120" />
      <el-table-column label="项目状态" sortable="custom" width="100">
        <template slot-scope="scope">
          <span
            :id="`status_${scope.row._id}`"
            class="popper-btn"
          >
            {{ scope.row['项目状态'] }} <i class="el-icon-arrow-down" />
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="地域" sortable="custom" label="地域" show-overflow-tooltip min-width="100" />
      <!-- <el-table-column prop="优先级" sortable="custom" label="优先级" width="120">
        <template slot-scope="scope">
          <i v-for="n in 5" :key="n" :class="n <= scope.row['优先级'] ? 'el-icon-star-on' : 'el-icon-star-off'" />
        </template>
      </el-table-column> -->
      <el-table-column prop="客户开发" sortable="custom" label="客户开发" min-width="100" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-if="Array.isArray(scope.row['客户开发'])" class="cell-multi">
            <span v-for="(val, index) in scope.row['客户开发']" :key="index" class="cell-multi-item">{{ val }}</span>
          </div>
          <span v-else>{{ scope.row['客户开发'] || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="项目对接" sortable="custom" min-width="100" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-if="Array.isArray(scope.row['项目对接'])" class="cell-multi">
            <span v-for="(val, index) in scope.row['项目对接']" :key="index" class="cell-multi-item">{{ val }}</span>
          </div>
          <span v-else>{{ scope.row['项目对接'] || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="项目经理" sortable="custom" min-width="100" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-if="Array.isArray(scope.row['项目经理'])" class="cell-multi">
            <span v-for="(val, index) in scope.row['项目经理']" :key="index" class="cell-multi-item">{{ val }}</span>
          </div>
          <span v-else>{{ scope.row['项目经理'] || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="项目成员" sortable="custom" min-width="100" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-if="Array.isArray(scope.row['项目成员'])" class="cell-multi">
            <span v-for="(val, index) in scope.row['项目成员']" :key="index" class="cell-multi-item">{{ val }}</span>
          </div>
          <span v-else>{{ scope.row['项目成员'] || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="开始时间" show-overflow-tooltip sortable="custom" width="130">
        <template slot-scope="scope">{{ moment(scope.row.startTime) || moment(scope.row.createdAt) || '--' }}</template>
      </el-table-column>
      <el-table-column label="进展天数" sortable="custom" width="95">
        <template slot-scope="scope">{{ passed(scope.row.startTime || scope.row.createdAt) || '--' }}</template>
      </el-table-column>
      <el-table-column label="实际推荐时间" show-overflow-tooltip width="100">
        <template slot-scope="scope">{{ moment(scope.row['实际推荐时间']) || '--' }}</template>
      </el-table-column>
      <el-table-column label="近期操作" show-overflow-tooltip width="130">
        <template slot-scope="scope">
          {{ scope.row['近期操作'] }}
        </template>
      </el-table-column>
      <el-table-column v-if="!simple" prop="项目人才" label="项目人才" width="100" align="center" />
      <el-table-column v-if="!simple" prop="Y" label="Y" width="60" align="center" />
      <el-table-column v-if="!simple" prop="F" label="F" width="60" align="center" />
      <el-table-column v-if="!simple" prop="N" label="N" width="60" align="center" />
      <el-table-column v-if="!simple" prop="未沟通" label="未沟通" width="90" align="center" />
      <el-table-column v-if="!simple" prop="已推荐" label="已推荐" width="90" align="center" />
      <el-table-column v-if="!simple" label="面试" width="70" align="center">
        <template slot-scope="scope">
          <a @click="showPipelineDetail('面试', scope.row['面试'])">
            {{ scope.row['面试'] ? scope.row['面试'].length : '0' }}
          </a>
        </template>
      </el-table-column>
      <el-table-column v-if="!simple" label="终面" width="70" align="center">
        <template slot-scope="scope">
          <a @click="showPipelineDetail('终面', scope.row['终面'])">
            {{ scope.row['终面'] ? scope.row['终面'].length : '0' }}
          </a>
        </template>
      </el-table-column>
      <el-table-column v-if="!simple" label="offer" width="80" align="center">
        <template slot-scope="scope">
          <a @click="showPipelineDetail('offer', scope.row['offer'])">
            {{ scope.row['offer'] ? scope.row['offer'].length : '0' }}
          </a>
        </template>
      </el-table-column>
      <el-table-column v-if="!simple" label="到岗" width="70" align="center">
        <template slot-scope="scope">
          <a @click="showPipelineDetail('到岗', scope.row['到岗'])">
            {{ scope.row['到岗'] ? scope.row['到岗'].length : '0' }}
          </a>
        </template>
      </el-table-column>
      <el-table-column
        v-if="!simple"
        label="auc_score"
        prop="auc_score"
        width="100"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
    </el-table>
    <Popper
      id="project-table-list-type"
      :visible.sync="popperVisible"
      :target-id="popperTarget"
      container="projectTableWrapper"
      class-name="shadow"
    >
      <FileTable
        v-if="popperType === 'files'"
        :files="files"
        :paginate="false"
        :height="FileTableHeight"
        width="700px"
      />
    </Popper>
    <interviewListDialog ref="interviewListDialog"></interviewListDialog>
    <PipelineDetail
      :visible.sync="pipelineDetailVisible"
      :title="pipelineDetailType"
      :data="pipelineDetailData"
    ></PipelineDetail>
  </div>
</template>

<script>
import { FileTable } from '../../../file'
import Popper from './Popper.vue'
import interviewListDialog from '../../../radish/src/dialog/interviewlist-dialog'
import PipelineDetail from '../dialog/PipelineDetail.vue'

const dateFormat = require('dateformat')

export default {
  components: {
    Popper,
    interviewListDialog,
    FileTable,
    PipelineDetail,
  },
  directives: {
    tablescroll: {
      bind(el, binding, vnode, oldVnode) {
        let scrollTop = 0
        const dom = el.querySelector('.el-table__body-wrapper')
        dom.addEventListener('scroll', e => {
          const isBottom = dom.scrollHeight - dom.scrollTop - 100 <= dom.clientHeight
          const isHorizontal = scrollTop == dom.scrollTop
          if (isBottom && !isHorizontal && dom.scrollTop != 0) {
            if (binding.value) {
              binding.value()
            }
          }
          if (!isHorizontal) {
            scrollTop = dom.scrollTop
          }
        })
      },
    },
  },
  props: {
    projects: { type: Array, default: () => [] },
    showDropdown: { type: Function, default: () => {} },
    simple: { type: Boolean, default: false },
  },
  data() {
    return {
      tableHeight: undefined,
      files: [],
      popperVisible: false,
      popperTarget: '',
      popperType: '',
      FileTableHeight: undefined,
      pipelineDetailType: '',
      pipelineDetailData: [],
      pipelineDetailVisible: false,
    }
  },
  watch: {
    height: {
      handler(val, oldVal) {
        this.tableHeight = val
      },
      immediate: true,
    },
  },
  mounted() {
    this.initHeight()
  },
  methods: {
    loadMore(){
      this.$emit('scrollbottom')
    },
    showAdvanced(project) {
      const jobRank = project['职级'] || []
      return jobRank.includes('1') || jobRank.includes('2')
    },
    initHeight() {
      this.$nextTick(() => {
        if (!this.$refs.projectTableWrapper) return
        const { height } = this.$refs.projectTableWrapper.getBoundingClientRect()
        if (height > 500) {
          this.tableHeight = height - 40
        } else {
          this.tableHeight = 500
        }
      })
    },
    moment(date) {
      return date ? dateFormat(new Date(parseInt(date, 10)), 'yyyy-mm-dd') : ''
    },
    passed(date) {
      return date ? `${Math.ceil((Date.now() - date) / (24 * 3600 * 1000))}天` : ''
    },
    showFiles(row, targetId) {
      this.files = row.files
      this.popperTarget = targetId
      this.popperVisible = true
      this.popperType = 'files'
    },
    onClickName(type, keywords) {
      window.app.root.search({
        type,
        keywords,
      })
    },
    async showPipelineDetail(type, list) {
      this.pipelineDetailVisible = true
      this.pipelineDetailType = type
      if (!list || list.length === 0) return
      const rids = list.map(val => val.rid).filter(Boolean)
      if (rids.length === 0) return
      const {
        status,
        data: { data },
      } = await app.service('radish').list({ query: { _id: rids } })
      if (status !== 'success') return (this.pipelineDetailData = list)
      data.forEach(radish => {
        list.forEach(obj => {
          if (radish._id === obj.rid) {
            this.mergeRadish(obj, radish)
          }
        })
      })
      this.pipelineDetailData = list
    },
    mergeRadish(target, radish) {
      target['姓名'] = radish['姓名'] || '--'
      target['性别'] = radish['性别'] || '--'
      target['公司'] = radish['公司'] || '--'
      target['部门'] = radish['部门'] || '--'
      target['目前职位'] = radish['目前职位'] || '--'
      target['手机'] = radish['手机'] || '--'
      target['地域'] = radish['地域'] || '--'
      target['职能模块'] = radish['职能模块'] || '--'
    },
  },
}
</script>

<style scoped>
.cell-multi {
  margin: 0 -5px;
}
.cell-multi-item {
  margin-right: 5px;
}
.project-table-wrapper {
  position: relative;
  height: 100%;
}
.cell .el-icon-star-on,
.project-table-wrapper .pointer {
  color: #409eff;
}
/* .ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ellipsis > .cell {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
.ellipsis .cell-edit-input {
  width: 100%;
} */
.shadow {
  box-shadow: 0px 2px 8px 0px rgba(232, 237, 250, 0.6), 0 2px 4px 2px rgba(232, 237, 250, 0.5);
}
</style>
